import KIAImage from '../ui/image/KIAImage';

interface Props {
  title: string;
  image?: string;
  link_style: string;
  description: string;
  cta?: {
    url: string;
    text: string;
  };
  articles: {
    title: string;
    text: string;
    link?: string;
    linkText?: string;
    image?: string;
  }[];
}

const NewsAgent = ({
  title,
  image,
  link_style,
  description,
  articles,
  cta,
}: Props) => {
  return (
    <section className="news_agent_container">
      <div className="news_agent_header">
        <h2 className="dynamic">{title}</h2>
        {image && (
          <KIAImage
            sizes="(max-width: 840px) 100vw, 840px"
            alt={title}
            src={image}
          />
        )}
        <p>{description}</p>
        {cta && (
          <span className="cta">
            <a href={cta.url} className="link-button">
              {cta.text}
            </a>
          </span>
        )}
      </div>
      <div className="news_agent_content">
        {articles.map((article, i) => {
          return (
            <article className="news_agent_article" key={i}>
              <div className="news_agent_article_header">
                {/* {article.image && <img src={article.image} alt={title} />} */}
                {article.image && (
                  <KIAImage
                    sizes="(max-width: 840px) 100vw, 400px"
                    alt={article.title}
                    src={article.image}
                  />
                )}
                <h3>{article.title}</h3>
              </div>
              <div className="news_agent_article_content">
                <p>{article.text}</p>
              </div>

              <div className="news_agent_article_footer">
                {article.link && (
                  <a className={`link-${link_style}`} href={article.link}>
                    {article.linkText ? article.linkText : 'Läs mer'}
                  </a>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default NewsAgent;
